module.exports = __webpack_public_path__ + "01309c90912c73432bdaf69a98d28314.svg";